// Security Configuration
export const SECURITY_CONFIG = {
  // Cloudflare Turnstile Configuration
  turnstile: {
    // Replace with your actual Cloudflare Turnstile site key
    // Get this from: https://dash.cloudflare.com/?to=/:account/turnstile
    siteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || 'YOUR_TURNSTILE_SITE_KEY',
    
    // Enable/disable Turnstile via environment variable
    // Set VITE_TURNSTILE_ENABLED=true in production, false in development
    enabled: import.meta.env.VITE_TURNSTILE_ENABLED === 'true',
    
    // Enable Turnstile on specific pages
    enableOnAuth: false,
    enableOnForms: false,
    enableOnAPI: false,
  },

  // Video Protection Configuration
  videoProtection: {
    // Enable anti-scraping measures
    enableDevToolsDetection: false, // Disabled for page-level, enabled only in video player
    enableContextMenuBlock: true,
    enableKeyboardShortcutBlock: true,
    enableWatermark: true,
    enableScreenRecordingDetection: false, // Disabled to avoid false positives
    
    // Rate limiting for video requests
    maxVideoRequestsPerMinute: 10,
    
    // Session validation
    validateSessionOnVideoPlay: true,
  },

  // API Security
  api: {
    // Rate limiting
    maxRequestsPerMinute: 60,
    maxLoginAttempts: 5,
    lockoutDuration: 15 * 60 * 1000, // 15 minutes in ms
    
    // Token configuration
    tokenRefreshThreshold: 5 * 60 * 1000, // 5 minutes in ms
    
    // Request signing (implement HMAC signatures)
    enableRequestSigning: true,
  },

  // Content Protection
  contentProtection: {
    // Disable text selection on sensitive content
    disableTextSelection: true,
    
    // Disable copy-paste
    disableCopyPaste: true,
    
    // Add invisible watermarks to text
    enableTextWatermark: true,
    
    // Obfuscate HTML content
    obfuscateContent: true,
  },

  // Bot Detection
  botDetection: {
    // Check for common bot user agents
    enableUserAgentCheck: true,
    
    // Check for headless browsers (disabled by default to avoid false positives)
    enableHeadlessDetection: false,
    
    // Check for automation tools
    enableAutomationDetection: true,
    
    // Track mouse/keyboard behavior
    enableBehaviorAnalysis: false,
  },
};

// Helper function to validate Turnstile token on backend
export const validateTurnstileToken = async (token: string): Promise<boolean> => {
  try {
    // This should be done on your backend
    const response = await fetch('/api/verify-turnstile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    });
    
    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error('Turnstile verification error:', error);
    return false;
  }
};
